module.exports = __webpack_public_path__ + "static/media/bed-moving-Icon-3.e47091e6.svg";